import { render } from "./xtx-infinite-loading.vue?vue&type=template&id=143fe429&scoped=true"
import script from "./xtx-infinite-loading.vue?vue&type=script&lang=js"
export * from "./xtx-infinite-loading.vue?vue&type=script&lang=js"

import "./xtx-infinite-loading.vue?vue&type=style&index=0&id=143fe429&scoped=true&lang=less"

import exportComponent from "F:\\workspan\\java\\three_2\\ui\\hk-lottery-lhc-pc-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143fe429"]])

export default __exports__